module.exports = __webpack_public_path__ + "media/pos-beep.70860b47.mp3";